<template>
  <div>
     <router-view></router-view>
    <notifications position="top right" :max="3"  :speed="500" />
    <notifications group="info" position="top center" :max="3" classes="alert  alert-primary rounded  p-5" :speed="500" :width="400" />
    
  </div>
</template>

<script>
import {store} from './store';
export default {
  name: 'app',
  beforeCreate: function () {
     if(!store.state.auth){
        this.$router.push('/'); 
     }
    },
  //   beforeMount(){
	// 	if (this.updateExists) {
  //       this.refreshApp();
  //     }

	// },
}
</script>
